import axios from "axios";

export function useAxios() {  
  const ajaxUrl = "https://portal.stust.edu.tw/contest2022api/";
  //const ajaxUrl = "https://localhost:7240/";
  const ajxUrl = "https://localhost:7240/";
  const ajax = axios.create({ baseURL: ajaxUrl });
  const ajx = axios.create({ baseURL: ajxUrl });
  const errmsg = (err) =>
    !!err.response == true && !!err.response.data == true
      ? err.response.data.message
      : err.message;

  // ajax.interceptors.response.use(
  //   (res) => res,
  //   (err) => {
  //     Error(errmsg(err));
  //     return err;
  //   }
  // );

  // ajx.interceptors.response.use(
  //   (res) => res,
  //   (err) => {
  //     Error(errmsg(err));
  //     return err;
  //   }
  // );

  return { ajax, ajx, ajaxUrl, ajxUrl, errmsg };
}
